module.exports = __webpack_public_path__ + "img/cornbread-dressing.842a4191.jpg";